export function getContainerStyle(theme) {
    return {
        root: {
            background: theme === null || theme === void 0 ? void 0 : theme.customSemanticColors.solidBackgroundQuarternary,
            height: "100%",
            padding: "40px 0px 0px 0px",
            width: "100%",
        },
    };
}
